<template>
<!-- Wrapper -->
<div id="wrapper">

	<!-- Header -->
	<RTHeader :title="title"/>

	<!-- Menü -->
	<RTNavigation/>


	<!-- ── NEWS BANNER ─────────────────────────────────────────── -->
	<div class="news-banner" v-if="showNewsBanner">
		<div class="news-banner-inner">
			<span class="news-label">NEU BEI VONTABLERN.DE</span>
			<h2 class="news-headline">
				Zwei neue Funktionen.<br>
				Noch <span class="news-highlight">mehr Möglichkeiten</span> für dich.
			</h2>

			<div class="news-cards">
				<!-- Feature 1 -->
				<div class="news-card">
					<div class="news-card-number">1.</div>
					<div class="news-card-body">
						<div class="news-card-content">
							<h3>Einträge können <span class="news-highlight">selbst aktualisiert werden</span></h3>
							<div class="news-card-divider"></div>
							<p>Aktualisiere deine Informationen, Bilder und Kontaktdaten jederzeit ganz einfach selbst.</p>
						</div>
						<div class="news-card-visual news-card-visual-small" aria-hidden="true">
							<svg viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect x="4" y="4" width="96" height="72" rx="6" fill="white" stroke="#d8d0f0" stroke-width="1.5"/>
								<rect x="12" y="14" width="34" height="28" rx="4" fill="#ede9f8"/>
								<rect x="12" y="50" width="50" height="5" rx="2.5" fill="#ede9f8"/>
								<rect x="12" y="60" width="38" height="5" rx="2.5" fill="#ede9f8"/>
								<rect x="56" y="50" width="28" height="14" rx="3" fill="#7c5cbf"/>
								<text x="62" y="61" font-size="7" fill="white" font-family="sans-serif">&#x270E; Edit</text>
								<circle cx="88" cy="28" r="14" fill="#7c5cbf"/>
								<text x="81" y="34" font-size="15" fill="white" font-family="sans-serif">&#x270E;</text>
							</svg>
						</div>
					</div>
				</div>
				<!-- Feature 2 -->
				<div class="news-card">
					<div class="news-card-number">2.</div>
					<div class="news-card-body">
						<div class="news-card-content">
							<h3>Tags können Shops <span class="news-highlight">zugeordnet werden</span></h3>
							<div class="news-card-divider"></div>
							<p>Ordne passende Tags deinem Shop zu und werde in der Suche noch besser gefunden.</p>
						</div>
						<div class="news-card-visual" aria-hidden="true">
							<div class="news-tag-demo">
								<span class="news-tag-chip">Nachhaltig <span>×</span></span>
								<span class="news-tag-chip">Bio <span>×</span></span>
								<span class="news-tag-chip">Training <span>×</span></span>
								<span class="news-tag-chip">Handmade <span>×</span></span>
								<span class="news-tag-add">+</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<button class="news-close" @click="showNewsBanner=false" aria-label="Schließen">×</button>
		</div>
	</div>

	<!-- 
Idee: Blende Stöbern | dienstleistungen
todo: search params für versand und kategorie

	-->

	<!-- Main -->
	<div id="main">
		<div class="inner">
			<div v-if="isLoading" class="loading-container">
				<div class="spinner"></div> 
				<p>Lade Unternehmen...</p>
			</div>
			<header v-else>
				<h1 v-html="subtitle"></h1>
				<p>
					<!--Das Tabler & Ladies - Universum ist groß, wenn nicht sogar grenzenlos!-->
					<br>Diese Seite verschafft Dir eine Übersicht über Unternehmen von Ladies & Tablern, die eigene Produkte sowie Dienstleistungen anbieten, um Direktkäufe ohne Umwege zu vereinfachen.
				</p>

				<div v-if="featuredShops" class="row mt-3">
					<h2>Empfehlung des Monats<a href="#" @click.prevent='showInfoModal' class="no-deco"><span class="icon solid fa-info-circle"></span></a></h2>		
						<section v-for="(featuredShop,index) in featuredShops" :key="index" class="w-100 mb-2 tiles" style="margin-top:-2em;margin-left: 0px">	
							<RTshop style="width:100%" class="featuredArticle" bgClass="bgShopFeatured" :shop="featuredShop" :isTouchDevice="isTouchDevice" @touched="onCardTouched" :activeId="touchedCardId" :shortenDescr="false"/>
							<!--
							<a :href="featuredShop.url" target="_blank" > 
								<div  style="width:100%;height:300px;">
									<RTImage class="v-card-static" :src="featuredShop.img" :alt="featuredShop.title" size="cover"></RTImage>
								</div>
								<div>{{featuredShop.descr}}</div>
							</a>
							-->
						</section>
				</div>
				<!--
				<div class="row">
					<div class="mt-1 pb-1 col-8 col-12-xsmall">
						Möchtest du darüber hinaus die Weiterentwicklung dieser Seite sichern, dann unterstütze den Betrieb durch einen Klick auf "Buy me a coffee". Jeglicher Überschuss kommt aktuell meinem Herzensprojekt <a class="primary-color" href="https://www.radzelten.de/" target="_blank"> "Music for Karakul"</a> zu Gute.
					</div>
					<div class="pt-05 mt-1 col-4 col-12-xsmall">
						<a class="no-deco" href="https://www.buymeacoffee.com/TobiasHubold" target="_blank"><img src="https://cdn.buymeacoffee.com/buttons/default-orange.png" alt="Buy Me A Coffee" style="height: 45px !important;width: 200px !important;" ></a>
					</div>
				</div>
				-->
				
				<div class="row mt-3 mb-0">
					<h2>Wonach suchst du heute?</h2>
					<ul class="actions fit m-1 topCatWrapper">
						<li><a href="#search" v-smooth-scroll @click="setTopCategory(1)" class="button" :class="{ primary: searchTopCategoryId==1 }">Produkte ({{getShopsWithTopCategoryCount(1,dataset)}})</a></li> <!-- wenn clicked: primary-->
						<li><a href="#search" v-smooth-scroll @click="setTopCategory(2)" class="button" :class="{ primary: searchTopCategoryId==2 }">Dienstleistungen ({{getShopsWithTopCategoryCount(2,dataset)}})</a></li>
						<li><a href="#map" v-smooth-scroll @click="setTopCategory(3)" class="button" :class="{ primary: searchTopCategoryId==3 }">Übernachtungen ({{getShopsWithTopCategoryCount(3,dataset)}})</a></li>
						<li><a href="#search" v-smooth-scroll @click="setTopCategory(4)" class="button" :class="{ primary: searchTopCategoryId==4 }" >Sonstiges ({{getShopsWithTopCategoryCount(4,dataset)}})</a></li>
					</ul>
				</div>
				<!-- Map --->
				<div v-if="searchTopCategoryId==3" id="map" class="row">
					<div style="max-height:400px;width:100%">
						<RTMap  :initialZoom="3" :items="(this.hasFilter)?seachedShops:dataset"/>
					</div>
				</div>

				<div class="row gtr-uniform mb-1 mt-0">
					<div class="col-4 col-3-medium col-12-xsmall">
						<input type="text" name="search" id="search" trim value="" placeholder="Suche" v-model="search">
					</div>
					<div class="col-3 col-12-xsmall">
						<select name="category" id="category" v-model="searchCategoryId">
							<option value="0">- Branche -</option>
							<option v-for="(cat,index) in sortedNotEmptyCategories" :key="index" :value="cat.id">{{cat.name}} ({{cat.length}})</option>
						</select>
					</div>
					<div class="col-3 col-7-xsmall">
						<select name="shipping" id="shipping" v-model="searchShippingId">
							<option value="0">- Versand -</option>
							<option v-for="(s,index) in shipping" :key="index" :value="s.id">{{s.name}}</option>
						</select>
					</div>
					<div class="col-1">
						<a href="#" @click.prevent="resetSearchParams()" class="p-1 button icon selector solid fa-times "></a>
					</div>
					<div class="pl-0 col-1 col-2-medium col-4-xsmall t-align-r">
						<a href="#" @click.prevent="gridView=true" :class="gridView?'button-selected':''" class="button icon selector solid fa-th-large ml-05"></a>
						<a href="#" @click.prevent="gridView=false" :class="!gridView?'button-selected2':''" class="button icon selector selectorgreen solid fa-th-list ml-05"></a>
					</div>
				</div>
			</header>

				<!-- Grid view -->
				<!-- Shop full infinite scroll list-->
				<div v-show="gridView">
					<section v-show="!this.hasFilter" class="tiles" >
						<RTshop v-for="(shop,index) in data" :key="index" :shop="shop" :isTouchDevice="isTouchDevice" @touched="onCardTouched" :activeId="touchedCardId"/>
					</section>
					<!-- Full Search list -->
					<section v-show="this.hasFilter" class="tiles">
						<RTshop v-for="(shop,index) in seachedShops" :key="index" :shop="shop" :isTouchDevice="isTouchDevice" @touched="onCardTouched" :activeId="touchedCardId"/>
					</section>
				</div>
				<!-- List view -->
				<div v-show="!gridView">
					<RTlist v-if="this.hasFilter"  :items="seachedShops" />
					<RTlist v-else :items="shops" />
				</div>
				<!-- empty search entry -->
				<p v-if="gridView && this.hasFilter && seachedShops.length<1" class="w-100 mt-2">
					<center>
					Leider ergab die Suche keine Treffer 
					</center>
				</p>
				<!-- Load more button -->
				<p v-if="gridView && !this.hasFilter && !this.maxEntriesReached" class="w-100 mt-5">
					<center><button class="fit" @click="loadMore"> <i class="icon solid fa-arrow-circle-down fa-lg"></i> Mehr Einträge anzeigen</button></center>
				</p>
		</div>
	</div>

	<!-- Modals -->
	<RTmodal ref="infoModal" :clickAndClose="false">
		<div class="inner">
			<h2>Empfehlung des Monats</h2>
			<p>Die Unternmehmenswelt unserer Ladies und Tabler ist so vielfältig, dass man manchmal den Überblick verliert.<br>Deshalb möchten wir wöchentlich ein Unternehmen in den Fokus rücken.</p>
			<p>Möchtest auch Du dein Unternehmen mehr Aufmerksamkeit geben, dann kontaktiere mich unter kontakt@tobiashubold.de</p>
		</div>
	</RTmodal>

	<!-- Footer -->
	<RTFooter></RTFooter>
</div>
</template>

<script>
import Vue from 'vue';
//import { Carousel, Slide } from 'vue-carousel';
import RTHeader from '@/components/RTHeader.vue'
import RTNavigation from '@/components/RTNavigation.vue'
import RTFooter from '@/components/RTFooter.vue'
import RTlist from '@/components/RTlist.vue'
import RTshop from '@/components/RTshop.vue'
import RTmodal from '@/components/RTmodal.vue'
import RTMap from '@/components/RTMap.vue'
import {categoryBase} from '@/mixins/categoryBase.js'
//import jsonShops from '@/assets/shops.json';
import jsonFeaturedShops from '@/assets/featured.json';
import {shopBase} from '@/mixins/shopBase.js'
import {helper} from '@/mixins/helper.js'

export default {
	name: 'ListView',
	mixins:[helper,categoryBase,shopBase],
	components: {
		RTHeader,
		RTNavigation,
		RTFooter,
		RTlist,
		RTshop,
		RTmodal,
		RTMap
		//Carousel,
		//Slide
	},
	data(){
		return{
			title:"Unternehmen von Ladies & Tablern",
			search:"",
			searchCategoryId:0,
			searchTopCategoryId:0,
			searchShippingId:0,
			data: [], //loaded data
			dataset:[], // full shuffled dataset
			page:1,
			count:50,//is set in mounted
			busy: false,
			shops: [], // Initial leer
			isLoading: true, // Neu: Ladestatus
			featuredShops:jsonFeaturedShops,
			theme:1,
			isTouchDevice:false,
			clickedShop:null,
			gridView:true,
			scrollposition:0,
			touchedCardId:null,
			blockedSearch:true,
			showNewsBanner: true
		}
	},
	watch:{
		/*
		search(v,o){
			this.setRouteParams('search',v,o);
		},
		searchShippingId(v,o){
			this.setRouteParams('searchShippingId',v,o);
		},
		searchCategoryId(v,o){
			this.setRouteParams('searchCategoryId',v,o);
		}
		*/

		// Reagiert auf Query-Parameter-Änderungen durch Vue Router
		// (z.B. wenn ShopView per Tag-Klick hierher navigiert)
		'$route.query'(newQuery) {
			if (newQuery.search !== undefined) {
				this.search = newQuery.search;
			}
			if (newQuery.searchCategoryId !== undefined) {
				this.searchCategoryId = newQuery.searchCategoryId;
			}
			if (newQuery.searchShippingId !== undefined) {
				this.searchShippingId = newQuery.searchShippingId;
			}
			if (newQuery.searchTopCategoryId !== undefined) {
				this.searchTopCategoryId = newQuery.searchTopCategoryId;
			}
		}
		
	},
	computed:{
		sortedNotEmptyCategories(){
			//nehme branchen von shops
			return this._.filter(this.sortedCategories,(cat)=>{
				/*
				if(this.searchTopCategoryId>0 && !this.compareWithCategories(cat.top_cat,this.searchTopCategoryId)){
					return false;
				}*/
				let searchDataset=this.dataset;
				if(this.hasSearchTopCategory){
					searchDataset= this._.filter(searchDataset,(shop)=>{
						return this.compareWithCategories(shop.top_cat,this.searchTopCategoryId);
					});
				}


				let count=this.getShopsWithCategoryCount(cat.id,searchDataset);
				cat.length=count;
				return count>0;
			});

		},
		maxEntriesReached(){
			return this.data.length>=this.dataset.length;
		},

        subtitle(){
            return "Kauf direkt und ohne Umwege von "+this.dataset.length+" Ladies & Tablern";
        },

		hasSearchCategory(){
			return (this.searchCategoryId>0);
		},
		hasSearchTopCategory(){
			return (this.searchTopCategoryId>0);
		},
		hasSearchShipping(){
			return (this.searchShippingId>0);
		},
		hasSearchString(){
			return (this.search && this.search.trim()!="");
		},
		hasFilter(){
			return this.hasSearchTopCategory || this.hasSearchCategory || this.hasSearchString || this.hasSearchShipping;
		},
		seachedShops(){
			let res=this.dataset;

			if(this.hasSearchCategory){
				res= this._.filter(res,(shop)=>{
					return this.compareWithCategories(shop.category,this.searchCategoryId);
				});
			}
			if(this.hasSearchTopCategory){
				res= this._.filter(res,(shop)=>{
					return this.compareWithCategories(shop.top_cat,this.searchTopCategoryId);
				});
			}
			
			if(this.hasSearchString){
				res= this._.filter(res,(shop)=>{
					// Tags als durchsuchbarer String
					const tagsStr = (Array.isArray(shop.tags) ? shop.tags.join(' ') : '');
					return (
						this.compareWithSearch(this.getCategoriesAsString(shop.category)) ||
						this.compareWithSearch(shop.title) ||
						this.compareWithSearch(shop.company) ||
						this.compareWithSearch(shop.descr) ||
						this.compareWithSearch(shop.name, true) ||
						this.compareWithSearch(shop.nr, true) ||
						this.compareWithSearch(tagsStr)
					);
				});
			}

			if(this.hasSearchShipping){
				res= this._.filter(res,(shop)=>{
					return this.compareWithShippings(shop.ship,this.searchShippingId);
				});
			}

			return res;
		}
	},
	methods:{
		async fetchShops() {
			try {
				const response = await fetch('/api.php');
				const data = await response.json();
				this.shops = data;
				this.dataset = this.getShuffledShops();
				this.loadMore();
			} catch (e) {
				console.log("Fehler beim Laden der Shops:");
			} finally {
				this.isLoading = false;
			}
		},
		showInfoModal() {
			this.$refs.infoModal.show();
		},
		setTopCategory(topCat){
			if(topCat>0){
				this.resetSearchParams();
				this.searchTopCategoryId=topCat;
			}
		},
		resetSearchParams(){
			this.search="";
			this.searchCategoryId=0;
			//this.searchTopCategoryId=0;
			this.searchShippingId=0;
		},
		onCardTouched(shop){
			if(shop){
				this.touchedCardId=shop.id;
			}
		},

		compareWithCategories(catIds,searchCatId){
			return this.compareIdWithIds(catIds,parseInt(searchCatId))
		},
		compareWithShippings(shipIds,seachShipId){
			return this.compareIdWithIds(shipIds,parseInt(seachShipId))
		},

		getShopsWithCategoryCount(catId,dataset){
			return this.getShopsWithAttrCount(catId,dataset,'category');
		},

		getShopsWithTopCategoryCount(catId,dataset){
			return this.getShopsWithAttrCount(catId,dataset,'top_cat');
		},

		enhanceData(){
			if(this.shops){
				this._.forEach(this.shops,(shop)=> {
					shop.shipText=this.getShippingAsString(shop);
					shop.img=this.getModifiedImage(shop.img);
				});
			}
		},
		getShuffledShops(){
			return this.setRandomColorToShops(this._.shuffle(this.shops));
		},
		getShopsByPage(page){
			let start=(page-1)*this.count;
			let end = (page*this.count);
			return this._.slice(this.dataset,start,end)
		},
		loadMore() {
			this.busy = true;
			let newShops=this.getShopsByPage(this.page);
			/*
			this._.forEach(newShops,(shop)=> {
				this.data.push(shop);
			});*/
			Vue.set(this,'data',this.data.concat(newShops));
			this.page++
			this.busy = false;
		},
		compareWithSearch(str){

			//let s1=(removeEmptySpaces)?replaced = str.split(' ').join('+');
			return (this._.isString(str))? str.toLowerCase().trim().includes(this.search.toLowerCase().trim()):false;
		},

		getStyleArticle(){
			return {
				'opacity':1
			}
		},
		setRandomColorToShops(shops){
			if(!this._.isEmpty(shops)){
				let index=1;
				return shops=this._.map(shops, (s)=>{
					let colorStyle="style"+index;
					s.headingColor="heading"+index;
					if(this.theme==1 || (null==s.img || s.img.trim()=="")){
						s.bgColor=colorStyle;
					}
					index++;
					if(index>6){
						index=1;
					}
					return s;
				});
			}
		},

		detectTouchDevice(){
			this.isTouchDevice=this.isMobileTouchDevice();
		},

		setTopCategoryOfShopByCategories(shop){
			if(shop){

				//jede category im shop durchgehen
				// category finden und top:_cat in extra array
				//unique cat array zurückgeben
				let res=[];
				if(shop.category){
					this._.forEach(shop.category,(catId)=>{
						let cat=this.getCategoryById(catId);
						if(cat){
							res=res.concat(cat.top_cat);
						}
					});
				}

				if(res.length>0){
					shop.top_cat=this._.uniq(res);
				}
			}
			return shop;
		},

		enhanceJsonFile(){

			//IDEE - kategorien zu produkten oder dienstleistungen soprtieren
			// Überall wo keine eindeutige zuorndung, da manuell

			for (let key in this.shops) {
				this.shops[key]=this.setTopCategoryOfShopByCategories(this.shops[key]);
				delete this.shops[key]['headingColor'];
				delete this.shops[key]['bgColor'];
				delete this.shops[key]['shipText'];	
				this.shops[key]['img']=this.shops[key]['img'].replace('https://vontablern.de','');	
			}
			console.log(this._.cloneDeep(this.shops));
		},
		setRouteParams(param,val,oldVal){
			if(this.$route && this.$route.query){
				try{
					// debugger // eslint-disable-line
					if(!this.blockedSearch && param && (param in this) && this.$route.query && (oldVal != this[param])){
						let obj={};
						obj[param]=val;
						this.$router.replace({query: obj});
					}
				}catch(e){
					console.log(e);
				}
			}
		},
		setVarParamsByRoute(param){
			if(this.$route && this.$route.query){
				if(this.$route.query && (param in this.$route.query)){
					this[param]=this.$route.query[param];
				}
			}
		},
		setAllVarParamsByRoute(){
			this.setVarParamsByRoute('search');
			this.setVarParamsByRoute('searchCategoryId');
			this.setVarParamsByRoute('searchTopCategoryId');
			this.setVarParamsByRoute('searchShippingId');

			setTimeout(()=>{
				this.blockedSearch=false;
			},500)
		}
	},
	
	activated() {
		//window.scrollTo(0, this.scrollposition);
	},
	beforeRouteLeave(to, from, next) {
		console.log('beforeRouteLeave');
		this.scrollposition = window.scrollY;
		next();
	},

	beforeRouteEnter: (to,from,next) => {
		next(vm => {
			setTimeout(()=>{
				window.scrollTo(0, vm.scrollposition);
			},300);
		});
	},

	mounted(){
		console.log('mounted');

		//this.enhanceJsonFile(); //--> just to add more attributes 
		this.detectTouchDevice();
		this.enhanceData();
		this.fetchShops(); // Daten vom Server holen
		this.count=(this.isTouchDevice)?20:50;
		this.loadMore();
		this.setAllVarParamsByRoute();
	}
}
</script>

<style>
/* ── NEWS BANNER ────────────────────────────────────────────── */
.news-banner{
	position: relative;
	background: #f5f3ff;
	border-bottom: 1px solid #e4dff5;
	padding: 2.5rem 1.5rem 2rem;
	margin-bottom:20px;
}
.news-banner-inner{
	max-width: 960px;
	margin: 0 auto;
	position: relative;
}
.news-label{
	display: inline-block;
	background: white;
	border: 1.5px solid #d8d0f0;
	border-radius: 6px;
	padding: .35rem .9rem;
	font-size: .72rem;
	font-weight: 700;
	letter-spacing: .1em;
	color: #6f4fcf;
	text-transform: uppercase;
	margin-bottom: 1.1rem;
}
.news-headline{
	font-size: clamp(1.6rem, 4vw, 2.6rem);
	font-weight: 800;
	color: #1a1a2e;
	line-height: 1.2;
	letter-spacing: -.02em;
	margin-bottom: .6rem;
}
.news-highlight{
	color: #7c5cbf;
}
.news-subline{
	font-size: .95rem;
	color: #666;
	margin-bottom: 2rem;
}
.news-cards{
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1.25rem;
	margin-bottom: 2rem;
}
.news-card{
	background: white;
	border: 1px solid #e4dff5;
	border-radius: 16px;
	padding: 1.5rem;
	display: flex;
	flex-direction: column;
	gap: .75rem;
}
.news-card-number{
	font-size: 2.2rem;
	font-weight: 800;
	color: #7c5cbf;
	line-height: 1;
	flex-shrink: 0;
}
/* Row: text left, visual right — same level, no overlap */
.news-card-body{
	display: flex;
	align-items: flex-start;
	gap: 1.25rem;
}
.news-card-content{
	flex: 1;
	min-width: 0;
}
.news-card-content h3{
	font-size: 1rem;
	font-weight: 700;
	color: #1a1a2e;
	line-height: 1.3;
}
.news-card-divider{
	width: 32px;
	height: 2px;
	background: #d8d0f0;
	border-radius: 2px;
	margin: .6rem 0;
}
.news-card-content p{
	font-size: .875rem;
	color: #555;
	line-height: 1.55;
}
/* Visual: fixed width, never shrinks */
.news-card-visual{
	flex-shrink: 0;
	width: 110px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: .5rem;
}
.news-card-visual svg{
	width: 100%;
	height: auto;
}
/* Tag demo in card 2 */
.news-tag-demo{
	background: white;
	border: 1px solid #e4dff5;
	border-radius: 10px;
	padding: .5rem .6rem;
	display: flex;
	flex-wrap: wrap;
	gap: .3rem;
	width: 110px;
	box-shadow: 0 2px 8px rgba(124,92,191,.1);
}
.news-tag-chip{
	background: #f0eef8;
	color: #6f4fcf;
	border: 1px solid #d8d0f0;
	border-radius: 999px;
	padding: .2rem .5rem;
	font-size: .72rem;
	font-weight: 600;
	display: inline-flex;
	align-items: center;
	gap: .2rem;
}
.news-tag-add{
	background: #ede9f8;
	color: #7c5cbf;
	border: 1.5px dashed #b8a8e0;
	border-radius: 999px;
	width: 22px;
	height: 22px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: .85rem;
	font-weight: 700;
}
.news-store-icon{
	width: 48px;
	opacity: .85;
}
.news-store-icon svg{ width:100%;height:auto; }
/* Footer row */
.news-footer{
	display: flex;
	align-items: center;
	gap: .625rem;
	font-size: .72rem;
	font-weight: 700;
	letter-spacing: .08em;
	color: #1a1a2e;
	text-transform: uppercase;
	border-top: 1px solid #e4dff5;
	padding-top: 1rem;
	flex-wrap: wrap;
}
.news-footer-heart{
	font-size: 1rem;
	color: #1a1a2e;
	letter-spacing: 0;
}
.news-footer-sub{
	color: #7c5cbf;
	letter-spacing: .08em;
	width: 100%;
	margin-top: -.25rem;
}
/* Close button */
.news-close{
	position: absolute;
	top: 0;
	right: 0;
	width: 50px;
	height: 50px;
	border: none;
	background: rgba(124,92,191,.1);
	border-radius: 50%;
	font-size: 1.2rem;
	color: #7c5cbf;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;
	transition: background .15s;
	box-shadow:inset 0 0 0 1px #585858;
}
.news-close:hover{
	background: rgba(124,92,191,.2);
}
/* Responsive */
@media screen and (max-width: 640px){
	.news-banner{ padding: 1.75rem 1rem 1.5rem; }
	.news-cards{ grid-template-columns: 1fr; gap: 1rem; }
	.news-headline{ font-size: 1.5rem; }
	/* On mobile: stack visual below text instead of hiding it */
	.news-card-body{ flex-direction: column; }
	.news-card-visual{ width: 100%; flex-direction: row; justify-content: flex-start; }
	.news-card-visual-small {width:40%;margin:auto;}
	.news-tag-demo{ width: auto; }
}
@media screen and (max-width: 420px){
	.news-headline{ font-size: 1.3rem; }
	.news-label{ font-size: .65rem; }
}

.headingFeatured{
	background-color: #6f6f6fc7;
	padding:1em;
}
.featuredArticle{
	margin-left:0!important;
}
.featuredArticle:hover .headingFeatured{
	background-color:unset;
}
.featuredArticle:hover .content{
	max-width: 600px;
}

.bgShopFeatured{
	background-position: 50% 50%!important;
}
@media screen and (min-width: 768px) {
		.bgShopFeatured{
				height:400px!important;
		}
	}
			
</style>
<style scoped>
	.topCatWrapper{
		width:100%;
		overflow: auto;
		padding-left:2em;
	}

	@media screen and (max-width: 480px) {
		.topCatWrapper{
			padding-left:1em;
		}
	}


	.rt_logo{
		color:black;
		fill: black;
	}

	.v-card,.v-card-static{
		border-radius:5px;
		-webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
		box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
	}
	.v-card:hover {
		-webkit-box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
		box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
	}

	.loading-container {
	text-align: center;
	padding: 50px;
	}
	.spinner {
	border: 4px solid rgba(0, 0, 0, 0.1);
	width: 36px;
	height: 36px;
	border-radius: 50%;
	border-left-color: #09f; /* Deine Primärfarbe */
	animation: spin 1s linear infinite;
	display: inline-block;
	}
	@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
	}
	
</style>